
import { VersionInterface } from './version.interface';

// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
var version: VersionInterface = {
    "dirty": true,
    "raw": "5a029b4-dirty",
    "hash": "5a029b4",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "5a029b4-dirty",
    "semverString": null,
    "version": "3.36.18",
    "date": "Thursday, June 5, 2025 11:15 AM"
};

 export { version, VersionInterface };
    